import { BaseModel } from "../Generics/BaseModel"

export class SelectionOptionEntity extends BaseModel {
  id: number

  name: string

  iconUrl: string

  icon: File | null

  isFree: boolean

  value: number

  allowMultiple: boolean

  maximumSelectionsLimit: number

  isOutOfStock: boolean

  hasStockControl: boolean

  stockQuantity: number

  constructor(data: Partial<SelectionOptionEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.name = data.name ?? ""

    this.iconUrl = data.iconUrl ?? ""

    this.icon = data.icon ?? null

    this.isFree = data.isFree ?? true

    this.value = data.value ?? 0

    this.allowMultiple = data.allowMultiple ?? false

    this.maximumSelectionsLimit = data.maximumSelectionsLimit ?? 1

    this.isOutOfStock = data.isOutOfStock ?? false

    this.hasStockControl = data.hasStockControl ?? false

    this.stockQuantity = data.stockQuantity ?? 0
  }
}
